import ProductTable from 'components/ProductPage/ProductTable/ProductTable';

export default ProductTable;
